<div
  class="modal-wrapper"
  role="dialog"
  aria-modal="true"
  data-cy="optins_close_confirmation_dialog"
  [style.backgroundColor]="config.backgroundColor"
>
  <p
    class="modal-title"
    [style]="{
      color: config.title.color,
      fontFamily: config.title.fontFamily,
    }"
    [innerHTML]="config.title.label | safe"
  ></p>

  <div class="modal-footer" [class]="config.actionButtons.variant">
    <b2c-button
      type="button"
      [attr.aria-label]="config.actionButtons.confirmButton.ariaLabel"
      [title]="config.actionButtons.confirmButton.ariaLabel"
      class="close-btn"
      data-cy="confirmation_back_btn"
      (click)="closeDialog(true)"
      [styles]="{
        color: config.actionButtons.confirmButton.textColor,
        fontFamily: config.actionButtons.confirmButton.fontFamily,
        borderRadius: config.actionButtons.confirmButton.borderRadius,
        backgroundColor: config.actionButtons.confirmButton.backgroundColor,
        fontSize: '14px',
        borderColor:
          config.actionButtons.confirmButton.borderColor ||
          config.actionButtons.confirmButton.backgroundColor,
      }"
    >
      {{ config.actionButtons.confirmButton.label }}</b2c-button
    >
    <b2c-button
      type="button"
      [attr.aria-label]="config.actionButtons.confirmButton.ariaLabel"
      class="close-btn"
      data-cy="confirmation_close_btn"
      (click)="closeDialog(false)"
      [styles]="{
        color: closeButtonConfig.textColor,
        fontFamily: closeButtonConfig.fontFamily,
        fontSize: '14px',
        borderRadius: closeButtonConfig.borderRadius,
        backgroundColor: closeButtonConfig.backgroundColor,
        borderColor:
          closeButtonConfig.borderColor || closeButtonConfig.backgroundColor,
      }"
    >
      {{ closeButtonConfig.label }}</b2c-button
    >
  </div>
</div>
